import { useState } from "react";
import styles from "./InstallPrompt.module.css";

const DISMISSED_KEY = "tohdoh_a2hs_dismissed";

function isIOSSafari(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;

  // Must be iOS (iPhone/iPad/iPod) — iPadOS 13+ reports as Mac with touch
  const isIOS = /iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 0);

  if (!isIOS) return false;

  // Exclude non-Safari browsers on iOS (Chrome, Firefox, Edge embed WebKit
  // but add their own UA tokens)
  if (/CriOS|FxiOS|EdgiOS/.test(ua)) return false;

  return true;
}

function isStandalone(): boolean {
  if (typeof navigator === "undefined") return false;

  // navigator.standalone is iOS-specific
  if ("standalone" in navigator && (navigator as { standalone?: boolean }).standalone === true) {
    return true;
  }

  // Fallback for display-mode media query
  if (typeof matchMedia === "function" && matchMedia("(display-mode: standalone)").matches) {
    return true;
  }

  return false;
}

export function InstallPrompt() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISSED_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed || !isIOSSafari() || isStandalone()) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISSED_KEY, "1");
    } catch {
      // localStorage unavailable — banner stays dismissed for this session
    }
  };

  return (
    <output className={styles.banner} aria-live="polite" data-testid="install-prompt">
      <span className={styles.text}>
        共有ボタンをタップして「ホーム画面に追加」するとデータが安全に保存されます。
      </span>
      <button type="button" className={styles.dismiss} onClick={handleDismiss} aria-label="閉じる">
        &times;
      </button>
    </output>
  );
}
